import { useNavigate, useParams } from 'react-router-dom';
import DefaultLayout from 'app/layouts/DefaultLayout';
import MainContentLayout from 'app/layouts/MainContentLayout';
import Path from 'app/route/Path';
import NavigationBackBtn from '../../../components/common/NavigationBackButton';
import DetailMenuManagementComponent from './DetailMenuManagementComponent';

function DetailMenuManagementPage() {
  const navigate = useNavigate();
  const { menuId } = useParams();

  if (!menuId) {
    navigate(Path.menuManagement);
    return null;
  }

  return (
    <DefaultLayout>
      <MainContentLayout containerClass="!overflow-visible">
        <div className="w-full mx-auto">
          <div className="sticky top-[38px] z-40 bg-white/95 backdrop-blur-sm flex items-center justify-between px-4 md:px-0 border-b border-slate-100 h-14 -mt-4">
            <h2 className="text-base lg:text-xl font-semibold">
              <NavigationBackBtn url={Path.menuManagement} text="メニュー管理" />
            </h2>
          </div>

          <DetailMenuManagementComponent
            menuId={menuId}
            onNotFound={() => navigate(Path.menuManagement)}
            onError={() => navigate(Path.menuManagement)}
          />
        </div>
      </MainContentLayout>
    </DefaultLayout>
  );
}

export default DetailMenuManagementPage;
